import React from "react";

import ArrowDownIcon from "../../images/icons/arrow-down-icon.inline.svg";
import ArrowRightBigIcon from "../../images/icons/arrow-right-big-icon.inline.svg";
import ArrowRightIcon from "../../images/icons/arrow-right-icon.inline.svg";
import ArrowRightSmall from "../../images/icons/arrow-right.inline.svg";
import DownloadIcon from "../../images/icons/fi-rr-download.inline.svg";
import { Link } from "../../utils/customLink";

const ApplyButton = ({
  ctaLabel,
  labelClass,
  arrowClass,
  target,
  to = "#",
  onClick = () => {},
  showAsButton = false,
  showArrowIcon = true,
  type = "apply",
  extraButtonStyle = "",
  arrowSize = "std",
  buttonStyle = "group relative z-10 flex flex-row items-center justify-center px-2 py-2 rounded-full bg-red-light text-white planet:rounded-sm planet:text-gray-darker planet:bg-green-standard hover:bg-black-lighter planet:hover:bg-white"
}) => {
  return (
    <>
      {showAsButton ? (
        <button
          onClick={onClick}
          className={`${buttonStyle} ${extraButtonStyle}`}
        >
          <p className={labelClass}>{ctaLabel}</p>

          {showArrowIcon && (
            <>
              {type === "apply" ? (
                <>
                  {arrowSize === "std" ? (
                    <ArrowRightIcon className={arrowClass} />
                  ) : arrowSize === "sml" ? (
                    <ArrowRightSmall className={arrowClass} />
                  ) : (
                    <ArrowRightBigIcon className={arrowClass} />
                  )}
                </>
              ) : type === "download" ? (
                <DownloadIcon className={arrowClass} />
              ) : (
                <ArrowDownIcon className={arrowClass} />
              )}
            </>
          )}
        </button>
      ) : (
        <Link
          to={to}
          target={target}
          className={`${buttonStyle} ${extraButtonStyle}`}
          onClick={onClick}
        >
          <p className={labelClass}>{ctaLabel}</p>

          {showArrowIcon && (
            <>
              {type === "apply" ? (
                <>
                  {arrowSize === "std" ? (
                    <ArrowRightIcon className={arrowClass} />
                  ) : arrowSize === "sml" ? (
                    <ArrowRightSmall className={arrowClass} />
                  ) : (
                    <ArrowRightBigIcon className={arrowClass} />
                  )}
                </>
              ) : type === "download" ? (
                <DownloadIcon className={arrowClass} />
              ) : (
                <ArrowDownIcon className={arrowClass} />
              )}
            </>
          )}
        </Link>
      )}
    </>
  );
};

export default ApplyButton;
